import React from "react";

import { FieldArray } from "react-final-form-arrays";

import { Body1, Body2 } from "Cobalt/BodyText";
import { CONTRIBUTION_TYPES } from "Common/Constants";
import { SIFinalFormFieldNoCol, SIFormInput } from "Common/forms";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("EditEmployeePriceBreakdown");

const contributionTypeToggle = (contributionType, onToggle) => {
  const percentageClass = ["contributionToggleButton", "left"];
  const fixedClass = ["contributionToggleButton", "right"];
  if (contributionType == CONTRIBUTION_TYPES.fixed) {
    fixedClass.push("selected");
  } else {
    percentageClass.push("selected");
  }
  return (
    <div className={bem("contributionToggleContainer")}>
      <button className={percentageClass.join(" ")} onClick={() => onToggle(CONTRIBUTION_TYPES.percentage)}>
        %
      </button>
      <button className={fixedClass.join(" ")} onClick={() => onToggle(CONTRIBUTION_TYPES.fixed)}>
        $
      </button>
    </div>
  );
};

const MobileContributions = ({ contributionType, contributionOptions, onToggle, usingTieredContributions, placeholderText }) => (
  <FieldArray name="contributions">
    {({ fields }) =>
      fields.map((name, index) => (
        <React.Fragment key={index}>
          <Row>
            {usingTieredContributions && (
              <Col className={bem("tierLabel")} pb={3}>
                <Body1>{Object.keys(contributionOptions)[index]}</Body1>
              </Col>
            )}
          </Row>
          <Row>
            <Col>
              <Div>
                <SIFinalFormFieldNoCol
                  name={`${name}.employee_contribution`}
                  label="For Employees"
                  componentProps={{
                    placeholder: placeholderText,
                    type: "number",
                  }}
                  component={SIFormInput}
                />

                {contributionTypeToggle(contributionType, onToggle)}
              </Div>
            </Col>
          </Row>
          <Row>
            <Col>
              <Div>
                <SIFinalFormFieldNoCol
                  name={`${name}.dependent_contribution`}
                  label="For Dependents"
                  componentProps={{
                    placeholder: placeholderText,
                    type: "number",
                  }}
                  component={SIFormInput}
                />

                {contributionTypeToggle(contributionType, onToggle)}
              </Div>
            </Col>
          </Row>
        </React.Fragment>
      ))
    }
  </FieldArray>
);

const DesktopContributions = ({ contributionType, contributionOptions, onToggle, usingTieredContributions, placeholderText }) => (
  <>
    {usingTieredContributions && (
      <Row pb={3}>
        <Col sm={4}>
          <Body2>Tier Type</Body2>
        </Col>
        <Col sm={4}>
          <Body2>For Employees</Body2>
        </Col>
        <Col sm={4}>
          <Body2>For Dependents</Body2>
        </Col>
      </Row>
    )}

    <FieldArray name="contributions">
      {({ fields }) =>
        fields.map((name, index) => (
          <Row key={index}>
            {usingTieredContributions && (
              <Col sm={4} className={bem("tierLabel")}>
                {Object.keys(contributionOptions)[index]}
              </Col>
            )}

            <Col sm={usingTieredContributions ? 4 : 12}>
              <Div mb={4}>
                <SIFinalFormFieldNoCol
                  name={`${name}.employee_contribution`}
                  label={!usingTieredContributions ? "For Employees" : undefined}
                  componentProps={{
                    placeholder: placeholderText,
                    type: "number",
                  }}
                  component={SIFormInput}
                />

                {contributionTypeToggle(contributionType, onToggle)}
              </Div>
            </Col>
            <Col sm={usingTieredContributions ? 4 : 12}>
              <Div>
                <SIFinalFormFieldNoCol
                  name={`${name}.dependent_contribution`}
                  label={!usingTieredContributions ? "For Dependents" : undefined}
                  componentProps={{
                    placeholder: placeholderText,
                    type: "number",
                  }}
                  component={SIFormInput}
                />

                {contributionTypeToggle(contributionType, onToggle)}
              </Div>
            </Col>
          </Row>
        ))
      }
    </FieldArray>
  </>
);

export const EditEmployeeMockContributions = ({ contributionType, contributionOptions, onToggle }) => {
  const usingTieredContributions = Object.keys(contributionOptions).length > 1;
  const placeholderText = `Enter ${contributionType == CONTRIBUTION_TYPES.fixed ? "amount" : "percentage"}`;
  return (
    <SizeSwitch
      xs={
        <MobileContributions
          contributionType={contributionType}
          contributionOptions={contributionOptions}
          onToggle={onToggle}
          usingTieredContributions={usingTieredContributions}
          placeholderText={placeholderText}
        />
      }
      sm={
        <DesktopContributions
          contributionType={contributionType}
          contributionOptions={contributionOptions}
          onToggle={onToggle}
          usingTieredContributions={usingTieredContributions}
          placeholderText={placeholderText}
        />
      }
    />
  );
};

export default EditEmployeeMockContributions;
